define('wanotifications', ['jquery', 'jquery.ui'], function ($) {

	var wanotifications = {
		msg: function msg(_msg, status, time, headline) {

			if (!!_msg) {
				var stat = !!status ? status : 'warning';
				var notification = $('.notification:not(.notification__static)');
				var notificationHeadline = notification.find('.notification__headline.' + status);
				var notificationHeadlineText = notificationHeadline.text();

				notificationHeadline.text(headline ? headline : notificationHeadlineText);

				notification.find('.notification__item').addClass(stat).end().find('.notification__image').addClass(stat).end().find('.notification__msg').html(_msg).end().stop().clearQueue().fadeIn(250).delay(!!time ? time : 4000).fadeOut();

				notification.on('click', function () {
					notification.hide();
				});
			}
		}
	};

	window.wanotifications = wanotifications;
	return wanotifications;
});

